// extracted by mini-css-extract-plugin
module.exports = {"formulario":"Formulario_formulario__3Ziy7","select":"Formulario_select__O-zB3","select__control":"Formulario_select__control__1m8Mx","alerta":"Formulario_alerta__1N4q8"};